setTimeout(function(){
    getVariantsWithPrice();
}, 1000);

function getVariantsWithPrice(){
    // Click quick add to cart button
    $('.satcb_quick_buy').click(function(){
        let handle = $(this).find("div[data-handle]").attr("data-handle");
        jQuery.getJSON(`${handle}.js`, function(product) {
            const variants = product.variants;
            const variants_with_price = [];
            if(variants.length > 1){
                // Add variants to new array if they are not a free gift variant
                variants.forEach(function(variant){
                    if(variant.price !== 0){
                        variants_with_price.push(variant);                        
                    }                    
                });
            } 
            // If the new array has only one variant, add that variant to cart
            if(variants_with_price.length === 1){
                quickAddToCart(variants_with_price[0]);
            }
        } );
    });
};

// This function is used to prevent free gift variants from being added to cart
function quickAddToCart(variant){
    let formData = {
        'items': [{
            'id': variant.id,
            'quantity': 1
        }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        return response.json();
    })
    .then(() => {
        this.updateCartBubble();
    })
    .catch((error) => {
        console.error('Error:', error);
    });        
}

// Update the sticky cart and header
function updateCartBubble(){
    jQuery.getJSON('/cart.js', function(cart) {
        $('#shopping-links .cart-icon .cart-count').html(`(${cart.item_count})`);
        $('#mobile-menu .cart-icon .cart-count').html(`${cart.item_count}`);
    } );
}
